import DataTableFooter from './DataTableFooter';

export default DataTableFooter;
